import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useUserAuth } from "../context/UserAuthContext";
import { db } from '../config/fbConfig';
import { doc, updateDoc } from "firebase/firestore";
import '../styles/PersonalInformation.css';
import Back from '../images/back2.webp';
import Logo from '../images/school_logo.png';
import Loader from "./Loader";
import SuccessModal from './SuccessModal';

const PersonalInformation = () => {
  const { user, userData } = useUserAuth();
  const [loading, setLoading] = useState(true);

  // State variables for input fields
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setphone] = useState("");
  const [field, setField] = useState("");
  const [qualification, setQualification] = useState("");
  const [address, setAddress] = useState("");
  const [phone1, setPhone1] = useState("");
  const [phone2, setPhone2] = useState("");
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [update, setUpdate] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const loadImage = (src) => {
      return new Promise((resolve) => {
        const img = new Image();
        img.src = src;
        img.onload = resolve;
      });
    };

    if (userData) {
      setFirstName(userData.firstName || "");
      setLastName(userData.lastName || "");
      setphone(userData.phone || "");
      setField(userData.field || "");
      setQualification(userData.qualification || "");
      setAddress(userData.address || "");
      setPhone1(userData.phone1 || "");
      setPhone2(userData.phone2 || "");
    }

    loadImage(Back).then(() => setLoading(false));
  }, [userData]);

  const handleUpdate = async (e) => {
    e.preventDefault();
    setError("");
    setUpdate(true);
    if (!user) return;

    const userDoc = doc(db, "users", user.uid);
    const updateData = {
      firstName,
      lastName,
      ...(userData?.status === "Parent" 
        ? { address, phone1, phone2 }
        : { phone, field, qualification }
      )
    };

    try {
      await updateDoc(userDoc, updateData);
      setUpdate(false);
      setSuccessMessage("Information updated successfully.");
      setShowModal(true);
    } catch (error) {
      setUpdate(false);
      setError("Update failed. Please try again.");
      setShowModal(true);
    }
  };

  if (loading) {
    return <Loader text={"LOADING"} />;
  }

  return (
    <>
      {update && <Loader text={"UPDATING"} />}
      <div className="top-elements row align-center space-between">
        <Link to="/home" className="back-link"><i className="fa-solid fa-arrow-left size3"></i></Link>      
        <div className="column align-center justify-center">           
          <img src={Logo} className="middle-logo" alt="logo" />
        </div>
        <Link to="#" className="home-link" onClick={() => window.location.reload()}><i className="fa-solid fa-rotate-right size4"></i></Link>
      </div>
      <div className="login-page-items column align-center" style={{backgroundImage: `url(${Back})`}}>
        { userData && (
          <form className="form-items" onSubmit={handleUpdate}>              
              <p className="login-heading align-center justify-center">PERSONAL INFORMATION</p>              
              <div className="info-item">
                <span className="font-gold bold size5">Name</span><br />                
                <input
                  className="edit-field size4"
                  type="text"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  placeholder="First Name"
                />
                <input
                  className="edit-field size4"
                  type="text"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  placeholder="Last Name"
                />
              </div>

              {userData.status === "Parent" ? (
                <>
                  <div className="info-item">
                    <span className="font-gold bold size5">Address</span><br />
                    <input
                      className="edit-field size4"
                      type="text"
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                      placeholder="Address"
                    />
                  </div>
                  <div className="info-item">
                    <span className="font-gold bold size5">Phone Numbers</span><br />
                    <input
                      className="edit-field size4"
                      type="text"
                      value={phone1}
                      onChange={(e) => setPhone1(e.target.value)}
                      placeholder="Primary Phone"
                    />
                    <input
                      className="edit-field size4"
                      type="text"
                      value={phone2}
                      onChange={(e) => setPhone2(e.target.value)}
                      placeholder="Secondary Phone"
                    />
                  </div>
                </>
              ) : (
                <>
                  <div className="info-item">
                    <span className="font-gold bold size5">Phone</span><br />
                    <input
                      className="edit-field size4"
                      type="text"
                      value={phone}
                      onChange={(e) => setphone(e.target.value)}
                      placeholder="Phone Number"
                    />
                  </div>
                  <div className="info-item">
                    <span className="font-gold bold size5">Field</span><br />
                    <input
                      className="edit-field size4"
                      type="text"
                      value={field}
                      onChange={(e) => setField(e.target.value)}
                      placeholder="Field"
                    />
                  </div>
                  <div className="info-item">
                    <span className="font-gold bold size5">Qualification</span><br />
                    <input
                      className="edit-field size4"
                      type="text"
                      value={qualification}
                      onChange={(e) => setQualification(e.target.value)}
                      placeholder="Qualification"
                    />
                  </div>
                </>
              )}
              
              <button type="submit" className="login-button">UPDATE</button>
          </form>
        )}      
      </div>
      {showModal && (
        <SuccessModal
          icon={error ? "xmark" : "check"}
          iconColor={error ? "red" : "green"}
          message={error || successMessage}
          onClose={() => {
            setError("");
            setSuccessMessage("");
            setShowModal(false);
          }}
        />
      )}
    </>
  );
};

export default PersonalInformation;